import { getSafe } from "../../../util/storeHelper";
import { activeGameId } from "../../profile_management/selectors";
import updateState, { isIdValid } from "./modUpdateState";
import * as React from "react";
import { connect } from "react-redux";
import Select from "react-select";
const PRESET_OPTIONS = [
    { value: "has-update", label: "Update available" },
    { value: "missing-meta", label: "Missing Meta ID" },
];
class VersionFilterComponent extends React.Component {
    render() {
        const { t, filter, mods } = this.props;
        const filterArr = Array.isArray(filter) ? filter : [];
        const versions = new Set();
        if (mods !== undefined) {
            for (const mod of Object.values(mods)) {
                const version = getSafe(mod, ["attributes", "version"], undefined);
                if (version !== undefined && version !== "") {
                    versions.add(version);
                }
            }
        }
        const versionOptions = Array.from(versions)
            .sort()
            .map((v) => ({ value: `v:${v}`, label: v }));
        const options = [
            ...PRESET_OPTIONS.map((o) => ({ ...o, label: t(o.label) })),
            ...versionOptions,
        ];
        return (React.createElement(Select, { multi: true, className: "select-compact", options: options, value: filterArr, onChange: this.changeFilter, autosize: false, placeholder: t("Filter...") }));
    }
    changeFilter = (value) => {
        const { attributeId, onSetFilter } = this.props;
        const values = [...new Set((Array.isArray(value) ? value : []).map((v) => v.value))];
        onSetFilter(attributeId, values.length > 0 ? values : undefined);
    };
}
function mapStateToProps(state) {
    const gameId = activeGameId(state);
    return {
        mods: gameId !== undefined ? state.persistent.mods[gameId] : undefined,
    };
}
const VersionFilterComponentConn = connect(mapStateToProps)(VersionFilterComponent);
class VersionFilter {
    component = VersionFilterComponentConn;
    raw = true;
    dataId = "$";
    matches(filter, value) {
        if (value === undefined) {
            return undefined;
        }
        if (!Array.isArray(filter) || filter.length === 0) {
            return true;
        }
        if (filter.includes("missing-meta") && !isIdValid(value)) {
            return true;
        }
        if (filter.includes("has-update") &&
            updateState(value.attributes) !== "current") {
            return true;
        }
        const versionFilters = filter
            .filter((f) => f.startsWith("v:"))
            .map((f) => f.slice(2));
        if (versionFilters.length > 0) {
            const version = getSafe(value, ["attributes", "version"], "") ?? "";
            if (versionFilters.includes(version)) {
                return true;
            }
        }
        return false;
    }
    isEmpty(filter) {
        return !Array.isArray(filter) || filter.length === 0;
    }
}
export default VersionFilter;
